/* eslint-disable:variable-name */

export type IDB_TSchema = Array<{
    name: string
    options: IDBObjectStoreParameters
}>

export const IDB_schema: IDB_TSchema = [
    // File Storage
    { name: 'files', options: { keyPath: 'fileId', autoIncrement: true } },
    // Activity Tables
    { name: 'activities', options: { keyPath: 'id' } },
    { name: 'activities_tasks', options: { keyPath: 'id' } },
    { name: 'task_report', options: { keyPath: 'id' } },
    // Planner
    { name: 'calendar_events', options: { keyPath: 'id' } },
    // Locations
    { name: 'locationFocusLists', options: { keyPath: 'locationFocusListId' } },
    { name: 'location_timeline_events', options: { keyPath: 'id' } },
    { name: 'location_ownerships', options: { keyPath: 'locationId' } },
    // Reports
    { name: 'locations', options: { keyPath: 'locationId' } },
    { name: 'reports', options: { keyPath: 'reportId', autoIncrement: true } },
    // Issues
    { name: 'issues', options: { keyPath: 'id' } },
    // Smart Data
    { name: 'smart_data', options: { keyPath: 'id' } },
    { name: 'smart_data_references', options: { keyPath: 'reference' } },
    { name: 'smart_data_ordering', options: { keyPath: 'source' } },
    // Buzz
    { name: 'fixes', options: { keyPath: 'fixId', autoIncrement: true } },
    // Units
    { name: 'units', options: { keyPath: 'id', autoIncrement: true } },
    { name: 'unit_types', options: { keyPath: 'id', autoIncrement: true } },
    { name: 'unit_lists', options: { keyPath: 'id', autoIncrement: true } },
    { name: 'forms', options: { keyPath: 'id', autoIncrement: true } },
    { name: 'campaigns', options: { keyPath: 'id', autoIncrement: true } },
    // Process flow
    { name: 'process_flows', options: { keyPath: 'id' } },
    { name: 'routed_units', options: { keyPath: 'id', autoIncrement: true } },
    { name: 'activity_overwrite', options: { keyPath: 'id', autoIncrement: true } },
    { name: 'report_status_updates', options: { keyPath: 'id', autoIncrement: true } },
    // Internationalisation
    { name: 'language_overrides', options: {} },
]
